import * as types from '../../mutation-types'
import RacesByTrainerService from '../../../services/racesByTrainer'

const actions = {
  get ({ commit, state }, id) {
    if (!id) {
      console.error('No trainer ID provided to getRacesByTrainer')
      return Promise.resolve()
    }

    return RacesByTrainerService.getAllRuns({ trainerId: id, pageSize: 500, filter: 'future' })
      .then((response) => {
        if (response && response.body && response.body.content) {
          const races = response.body.content
          races.sort(function (a, b) {
            return new Date(a.date) - new Date(b.date)
          })
          commit(types.GET_RACES_BY_TRAINER, {
            races: races
          })
        }
        return response
      })
      .catch(error => {
        console.error('Error getting races by trainer:', error)
        return Promise.reject(error)
      })
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/racesByTrainer/actions.js